import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-filter-string',
    templateUrl: './filter-string.component.html',
    styleUrls: ['./filter-string.component.scss'],
    standalone: false
})
export class FilterStringComponent implements OnInit {

  @Input() filter: any;
  @Input() section: any;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
